import { useMutation, UseMutationConfig } from '@libs/use';
import { UpdateInitialPublicOffer } from '@libs/api-reference';

import * as API from '../requests';

function updateOfferFactory(data: UpdateInitialPublicOffer) {
  return {
    ...data,
    orderExecutionType: 'Desktop-Helium-IPO',
  };
}

type UseUpdateInitialPublicOfferQueryType = {
  onSuccess?: UseMutationConfig<any>['onSuccess'];
  onReject?: UseMutationConfig<any>['onReject'];
};

export default function useUpdateInitialPublicOfferQuery({
  onReject,
  onSuccess,
}: UseUpdateInitialPublicOfferQueryType) {
  const { execute: updatePublicInitialOffer, ...query } = useMutation(
    (data: UpdateInitialPublicOffer) =>
      API.updateInitialPublicOffer(updateOfferFactory(data)),
    {
      onSuccess,
      onReject,
    }
  );

  return { updatePublicInitialOffer, ...query };
}
